var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63,
    height: 46,
    viewBox: "0 0 63 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.19.093h12.838v22.891H.191z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#001B3A",
    d: "M28.187 27.105h-2.965V9.58h-3.091V7.158h9.142V9.58h-3.086zM40.174 27.105v-7.833h-3.872v7.833h-2.921v-17.08c0-1.576 1.317-2.867 2.921-2.867h3.913c1.606 0 2.924 1.291 2.924 2.866v17.08h-2.965zm-3.872-10.297h3.872V9.54h-3.872v7.27zM49.28 27.346c-1.606 0-2.923-1.29-2.923-2.867V10.024c0-1.575 1.317-2.866 2.923-2.866h4.034a2.871 2.871 0 0 1 2.883 2.866v4.2h-2.923V9.539H49.28v15.425h4.365V19.15h-2.184v-2.504h4.9v7.833a2.868 2.868 0 0 1-2.88 2.867H49.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAC680",
    d: "M52.06 45.783L32.05 34.153H0V.277h62.722v33.876H49.92l2.14 11.63zM1.96 32.231h30.626l16.786 9.754-1.796-9.754h13.186V2.198H1.96v30.033z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.073 .184)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#239CBF",
    d: "M13.028 22.984V.093H.191v22.891l6.418-6.36 6.42 6.36zm-1.611-11.68l-3.31.698 2.241 2.513-1.96 1.433-1.743-2.899-1.743 2.899-1.995-1.433 2.208-2.443-3.312-.768.748-2.303 3.063 1.325-.248-3.352h2.49l-.39 3.282 3.168-1.291.783 2.34z",
    mask: "url(#b)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagLogo);
export default __webpack_public_path__ + "static/media/tag-logo.6395d61b8a9502d3cceaa8520d646337.svg";
export { ForwardRef as ReactComponent };